"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentStateField = void 0;
var ComponentStateField;
(function (ComponentStateField) {
    ComponentStateField["ON"] = "on";
    ComponentStateField["LEVEL"] = "level";
    ComponentStateField["HEATER_ON"] = "heaterOn";
    ComponentStateField["PUMP_ON"] = "pumpOn";
    ComponentStateField["FAN_SPEED"] = "fanSpeed";
    ComponentStateField["LID_OPEN"] = "lidOpen";
    ComponentStateField["DISCONNECTED"] = "disconnected";
    ComponentStateField["STATE"] = "state";
    ComponentStateField["SET_TEMPERATURE"] = "setTemp";
    ComponentStateField["MODE"] = "mode";
    ComponentStateField["LIGHT_ON"] = "lightOn";
    ComponentStateField["ALARM"] = "alarm";
})(ComponentStateField = exports.ComponentStateField || (exports.ComponentStateField = {}));
//# sourceMappingURL=ComponentStateField.js.map